import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const logService = {
    getAllLogs
};

const MODULE = {
    LOG: 'status-logs',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllLogs(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_locked: filter.isLocked,
            is_active: filter.isActive,
            report_uuid: filter.reportID
        }
    }


    return apiHelper(API_URL).get(`/${MODULE.LOG}`, requestOptions)
}